module.exports = __webpack_public_path__ + "img/ai-sparkle.a9cffeee.svg";